define('viewModels/privileged/qm/policies/editors/QueueSelectorView',[
    'lib/lodash4',
    'lib/bluebird',
    'lib/knockout',
    'services/queuesService',
    'services/loggingService',
    'viewModels/ViewModel',
    'services/toastService',

    // No references
    'extensions/i18n/knockout.i18n',
    'lib/knockout.validation'
], function (_, Promise, ko, queuesService, LOG, ViewModel, toasts) {
    'use strict';

    /**
     * The QueueSelectorView class.
     * @class
     */
    var QueueSelectorView = ViewModel.extend(function (queuesObservable, options) {
        var self = this;

        self.queues = queuesObservable;
        self.placeholderText = ko.i18n.renderString('queueSelectorView.placeholderText');
        self.isOpen = ko.observable(false);

        if (!ko.isObservable(queuesObservable)) {
            throw "QueueSelectorView needs an observable for its queuesObservable parameter.";
        }

        self.getQueues = function (searchTerm) {
            var filterObject = {
                pageSize: 25
            };
            var nameFilter = searchTerm;
            if (nameFilter.length > 0) {
                filterObject.name = nameFilter;
            }

            return queuesService.getQueuesBrief(filterObject)
            .then(function (response) {
                var unwrappedQueues = ko.unwrap(self.queues);

                // Transform the response
                var filteredQueues = _.map(response.entities, function(briefQueue) {
                    return {'id': briefQueue.id, 'name': briefQueue.name};
                });

                // Remove the already-selected queues from the list
                _.remove(filteredQueues, function (queue) {
                    return _.find(unwrappedQueues, {"id": queue.id});
                });

                //Removes ignored queues if specified.
                if (options && options.ignoredIds) {
                    _.remove(filteredQueues, function(queue) {
                        return _.includes(options.ignoredIds(), queue.id);
                    });
                }

                return filteredQueues;
            })
            .catch(function (error) {
                LOG.error("Couldn't retrieve queues for query", { error: error });
                toasts.notifyMinorAlert('policyEditor.listQueue.error');
                return [];
            });
        };

        if (_.isArray(self.queues())) {
            self.queues.extend({deepComparer: true, minLength: {params: 1, message: "queueSelectorView.noQueuesSelected"}});
        } else {
            self.queues.extend({required: true});
        }

    }, true /* pass args to extended class */);

    return QueueSelectorView;
});

